import * as React from "react";
import { observer } from "mobx-react-lite";
import { classNames } from "src/common/classNames";
import { DownOutlined } from "@ant-design/icons";
import { GanttLeftRow, Planning2GanttStore } from "../Planning2GanttStore";
import styles from "./Planning2NameCell.module.less";

type PropsPlanning2NameCell = {
  gantt: Planning2GanttStore;
  row: GanttLeftRow;
};

export const Planning2NameCell: React.FC<PropsPlanning2NameCell> = observer(
  (props) => {
    const { gantt, row } = props;
    const { id, name } = row;
    if (row.kind === "task") {
      return (
        <button
          type="button"
          className={classNames([
            styles.taskName,
            [!!row.level, styles.levelSpace],
          ])}
          title={name}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            gantt.tableStore.setCurrentTask({ id, name });
          }}
        >
          {name}
        </button>
      );
    }
    const { tableStore } = gantt;
    const groupExpanded = tableStore.expanded.has(id);
    return (
      <button
        type="button"
        className={classNames([styles.groupName])}
        onClick={() => tableStore.changeExpand(id, !groupExpanded)}
      >
        <DownOutlined
          rotate={groupExpanded ? 180 : undefined}
          className={styles.expandIcon}
        />
        <span>
          {name}: {row.children.length}
        </span>
      </button>
    );
  },
);
